import React, { memo } from 'react';
import CommentInput from './CommentInput';
import useRequestCommentCommon from '../../hooks/useRequestCommentCommon';

const CommentMessage = ({ plan, label, latest = false, value = '', isEditing = false }) => {
    const { isCommentReadOnly, updatedByDisplay } = useRequestCommentCommon({ plan });
    return (
        <CommentInput
            label={label}
            defaultValue={value}
            caseId={plan.case_id}
            planId={plan.plan_id}
            updatedDate={plan?.comment_updated_date}
            readOnly={isCommentReadOnly}
            isEditing={isEditing}
            updatedBy={updatedByDisplay}
            created_date={plan?.comment_created_date}
        />
    );
};

export default memo(CommentMessage);
